import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    travelDate: '',
    duration: '',
    travelers: '',
    interests: [],
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({
    show: false,
    type: '', // 'success' or 'error'
    message: ''
  });

  // Sample interests
  const interestOptions = [
    'Backwater Cruises',
    'Beaches',
    'Hill Stations',
    'Wildlife',
    'Ayurveda & Wellness',
    'Culture & Heritage',
    'Culinary Experiences',
    'Homestays'
  ];

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    
    if (!formData.country.trim()) {
      newErrors.country = 'Country is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleInterestChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData({
        ...formData,
        interests: [...formData.interests, value]
      });
    } else {
      setFormData({
        ...formData,
        interests: formData.interests.filter(interest => interest !== value)
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      country: formData.country,
      travelDate: formData.travelDate,
      duration: formData.duration,
      travelers: formData.travelers,
      interests: formData.interests.join(", "),
      message: formData.message,
    };

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbzioXJpmTHbdwgwS6SSIhkxHSqg5_4RK_AjIgDyPN0J1DvFTja80RHmXwzN8PZY9ZNDUg/exec", {
        method: "POST",
        redirect: "follow",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
      });

      const result = await response.json();

      if (result.result === "success") {
        setSubmitStatus({
          show: true,
          type: 'success',
          message: 'Your enquiry was submitted successfully!'
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          country: '',
          travelDate: '',
          duration: '',
          travelers: '',
          interests: [],
          message: ''
        });
        setErrors({});
      } else {
        setSubmitStatus({
          show: true,
          type: 'error',
          message: 'Submission failed. Please try again.'
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitStatus({
        show: true,
        type: 'error',
        message: 'An error occurred. Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }

    // Hide the message after 5 seconds
    setTimeout(() => {
      setSubmitStatus({
        show: false,
        type: '',
        message: ''
      });
    }, 5000);
  };

  return (
    <div className="contact-page">
      {submitStatus.show && (
        <div className={`submit-message ${submitStatus.type}`}>
          {submitStatus.message}
        </div>
      )}
      <div className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content">
          <h1>Contact Us</h1>
          <p>Let's start planning your dream Kerala vacation</p>
        </div>
      </div>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>We're here to help you plan your perfect Kerala vacation. Reach out to us with any questions or to start planning your journey.</p>

              <div className="contact-methods">
                <div className="contact-method">
                  <FaPhone className="contact-icon" />
                  <div>
                    <h3>Call Us</h3>
                    <p>+91 9818043272</p>
                    <p>+91 9818060273</p>
                  </div>
                </div>

                <div className="contact-method">
                  <FaEnvelope className="contact-icon" />
                  <div>
                    <h3>Email Us</h3>
                    <p>info@holisticholidays.in</p>
                  </div>
                </div>

                <div className="contact-method">
                  <FaWhatsapp className="contact-icon" />
                  <div>
                    <h3>WhatsApp</h3>
                    <p>+91 9818043272</p>
                    <p>+91 9818060273</p>
                  </div>
                </div>

                <div className="contact-method">
                  <FaMapMarkerAlt className="contact-icon" />
                  <div>
                    <h3>Reg.Office:</h3>
                    <p>Holistic Holidays LLP</p>
                    <p>Palackathadathil</p>
                    <p>Palakkuzha</p>
                    <p>Koothattukulam PO, Ernakulam</p>
                    <p>Kerala, India - 686662</p>
                  </div>
                </div>
              </div>

              {/* <div className="office-hours">
                <h3>Office Hours</h3>
                <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                <p>Sunday: Closed</p>
              </div> */}
            </div>

            <div className="enquiry-form">
              <h2>Enquiry Form</h2>
              <p>Fill out the form below and we'll get back to you as soon as possible.</p>

              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className={`form-control ${errors.name ? 'error' : ''}`}
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <span className="error-message">{errors.name}</span>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className={`form-control ${errors.email ? 'error' : ''}`}
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="country">Country *</label>
                    <input
                      type="text"
                      id="country"
                      name="country"
                      className={`form-control ${errors.country ? 'error' : ''}`}
                      value={formData.country}
                      onChange={handleChange}
                    />
                    {errors.country && <span className="error-message">{errors.country}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="travelDate">Preferred Travel Date</label>
                    <input
                      type="date"
                      id="travelDate"
                      name="travelDate"
                      className="form-control"
                      value={formData.travelDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="duration">Duration (in days)</label>
                    <input
                      type="number"
                      id="duration"
                      name="duration"
                      min="1"
                      className="form-control"
                      value={formData.duration}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="travelers">Number of Travelers</label>
                  <input
                    type="number"
                    id="travelers"
                    name="travelers"
                    min="1"
                    className="form-control"
                    value={formData.travelers}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Interests (Check all that apply)</label>
                  <div className="interests-grid">
                    {interestOptions.map((interest) => (
                      <div key={interest} className="interest-option">
                        <input
                          type="checkbox"
                          id={interest}
                          name="interests"
                          value={interest}
                          checked={formData.interests.includes(interest)}
                          onChange={handleInterestChange}
                        />
                        <label htmlFor={interest}>{interest}</label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Additional Information</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    className="form-control"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your travel preferences, special requirements, or any questions you have."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="btn btn-primary btn-block"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending Request...' : 'Submit Enquiry'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <h2>Find Us</h2>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.9642443797196!2d76.59532067478734!3d9.884292090211727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b064cfd9f38df95%3A0xfdd850f1b2d6a8ff!2sKoothattukulam%2C%20Kerala!5e0!3m2!1sen!2sin!4v1714818496247!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="Office Location">
            </iframe>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage; 